export const games = {
  titleBreakingLeague: "BREAKING THE LEAGUE",
  titleBreakingLeagueMobile: "💥 BREAKING THE LEAGUE",
  gamesSubTitle: "They don't want to leave anything for anyone.",
  recentTitle: "THE MOST RECENT",
  recentTitleMobile: "📢 THE MOST RECENT",
  recentSubTitle: "Try your luck with our new games",
  newLabel: "NEW",
  top10GamesTitle: "TOP",
  top10GamesTitle2: "GAMES",
  top10GamesSubTitleDesktop: "This week's favorites",
  top10GamesSubTitleMobile: "The <highlight>10</highlight> most played in all of Venezuela",
  randomTitle: "Can't decide?",
  randomTitleMobile: "🍀 Let luck decide!",
  randomDescription: "Hit play and let luck decide.",
  randomDescriptionMobile: "Hit play and let luck decide.",
  selectCategory: "Choose a category",
  randomPlayButton: "Let's play!",
  randomQuestion: "Which will be the next game to bring you luck? 🍀",
  randomButton: "Go to game 🚀",
  randomChipAll: "All",
  randomTryAnother: "Try another",
  randomNoGames: "No games in this category",
  randomPromoTitle: "Discover your next favorite game",
  randomPromoText: "Thousands of games await you. Let luck choose for you and discover new experiences.",
  randomPromoHint: "Try the random picker →",
  topPayingGamesTitle: "TOP PAYING GAMES",
  topPayingGamesSubTitle: "Dropping money nonstop",
  recentlyPlayedTitle: "CONTINUE WHERE YOU LEFT OFF",
  recentlyPlayedSubTitle: "Pick up the action with your last games",
  favoritesPageTitle: "❤️ {{alias}}, these are your favorites",
  favoritesPageTitleGeneric: "❤️ Your favorite games",
  favoritesPageSubtitle: "The games you love the most, all in one place",
  favoritesGridTitle: "{{alias}}'S FAVORITES",
  favoritesGridTitleGeneric: "YOUR FAVORITES",
  favoritesEmptyMessage:
    "You don't have any favorite games yet. Mark your favorite games by tapping the heart icon and come back here whenever you want to play your top picks.",
  favoritesAdd: "Add to favorites",
  favoritesRemove: "Remove from favorites",
  favoritesContinueTitle: "{{alias}}, pick up where you left off",
  favoritesContinueSubTitle: "Jump back into your recent games",
  homeFavoritesCarouselTitle: "{{alias}}, play your favorites",
  homeFavoritesCarouselTitleGeneric: "PLAY YOUR FAVORITES",
  homeFavoritesCarouselSubTitle: "Your top games, always at hand",
  lotteryGamesTitle: "LOTTERY GAMES",
  lotteryGamesSubTitle: "Try your luck with our lottery games",
  animalitosExpressTitle: "QUICK BUY ANIMALITOS",
  animalitosExpressSubTitle: "Pick, buy and win instantly",
  animalitosExpressBuy: "Buy",
  animalitosExpressAll: "All",
  qbErrorAmount: "Enter a valid amount",
  qbErrorMinBet: "Minimum {{min}} Bs",
  qbErrorMaxBet: "Maximum {{max}} Bs",
  qbErrorBalance: "Insufficient balance",
  qbErrorDrawClosed: "Draw closed",
  qbSuccessTitle: "Purchase successful!",
  qbClose: "Close",
  qbAriaLabel: "Quick buy animalito",
  qbNextDraw: "Draw",
  qbNoDraws: "No draws available",
  qbDrawClosed: "Closed",
  qbAmountLabel: "Bet amount",
  qbConfirm: "Confirm purchase",
  providerBgamingTitle: "BGAMING GAMES",
  providerBgamingSubtitle: "The best BGaming games",
  providerEvoplayTitle: "EVO PLAY GAMES",
  providerEvoplaySubtitle: "Unlimited fun with Evo Play",
  providerPragmaticTitle: "PRAGMATIC GAMES",
  providerPragmaticSubtitle: "The best of Pragmatic Play",
  allGamesTitle: "ALL GAMES",
  subcategoryAll: "All",
  subcategoryShowMore: "Show more",
  subcategoryShowLess: "Show less",
  subcategoryFilterLabel: "Filter by subcategory",
  dontMiss: "DON'T MISS ANY TOURNAMENT",
  dontMissTournaments: "Don't miss any of the Aprieta y Gana tournaments",
  tournamentRules: "Rules",
  promoFeatured: "Featured Event",
  promoPrizePool: "Prize Pool",
  promoTimeLeft: "Time Left",
  promoTimeLeftDays: "d",
  promoTimeLeftHours: "h",
  promoTimeLeftMinutes: "m",
  promoPlayers: "Players",
  promoRecentPlayers: "Recent players",
  promoViewProfile: "Profile",
  promoViewStories: "Stories",
  promoAddContact: "Add",
  promoJoinNow: "Join",
  promoLearnMore: "Learn more",
  promoViewGames: "View Games",
  promoLive: "LIVE",
  promoCasinoLive: "BEST OF LIVE CASINO",
  promoContests: "LIVE CONTESTS",
  // Multi-Game Floating Button translations
  multiGameFloatingButton: "Quick Games",
  quickGamesTitle: "Quick Games",
  quickGamesDescription: "Keep playing while waiting for your main game!",
  hideQuickGames: "Hide",
  minimizeQuickGames: "Minimize",
  playNow: "Play Now",
  noQuickGamesAvailable: "No games available at the moment",
  unknownGame: "Unknown Game",
  unknownProvider: "Unknown",
  loadingGames: "Loading games...",
  gameLoading: "Loading game",
  gameErrorTitle: "Could not load the game",
  gameErrorDescription: "Something went wrong while opening the game. Check your connection and try again.",
  gameRetry: "Retry",
  gameGoBack: "Go back",
  miniJuegosHeroTitle: "Mini Games",
  miniJuegosHeroAccent: "Fast",
  miniJuegosHeroSub: "Fast, intense, action-packed games. Win in seconds.",
  miniJuegosStatGames: "Games",
  miniJuegosStatCategories: "Categories",
  miniJuegosCategories: "Mini Games Categories",
  miniJuegosLoading: "Loading mini games...",
  miniJuegosEmpty: "No mini games available",
  miniJuegosCatAll: "All",
  miniJuegosCat_crash: "CRASH GAMES",
  miniJuegosCatSub_crash: "Bet and cash out before the crash",
  miniJuegosCat_chicken: "CHICKEN GAMES",
  miniJuegosCatSub_chicken: "Chicken adventures and prizes",
  miniJuegosCat_mines: "MINESWEEPER",
  miniJuegosCatSub_mines: "Avoid the mines and win",
  miniJuegosCat_plinko: "PLINKO",
  miniJuegosCatSub_plinko: "Drop and multiply",
  miniJuegosCat_sports: "SPORTS",
  miniJuegosCatSub_sports: "Casual and sports games",
  miniJuegosCat_lottery: "LOTTERY",
  miniJuegosCatSub_lottery: "Scratch, spin and win instantly",

  // Hero Banner Slide 2 translations
  casinoSlide2Title: "Live the ",
  casinoSlide2Accent: "Experience",
  casinoSlide2Sub: "Roulette, Blackjack, Baccarat and more with professional live dealers.",
  slotsSlide2Title: "Your fun ",
  slotsSlide2Accent: "without limits",
  slotsSlide2Sub: "Thousands of slots, table games and more waiting for you.",
  miniJuegosSlide2Title: "Win ",
  miniJuegosSlide2Accent: "Instantly",
  miniJuegosSlide2Sub: "Crash, Mines, Plinko and more fast games with instant prizes.",
  lotterySlide2Title: "Results ",
  lotterySlide2Accent: "in Real Time",
  lotterySlide2Sub: "Follow your favorite draws and collect your prizes instantly.",
  horsesSlide2Title: "Bet ",
  horsesSlide2Accent: "Live",
  horsesSlide2Sub: "National and international races with live streaming.",
  gameSearchPlaceholder: "Search games...",
  gameSearchAriaLabel: "Search games",
  gameSearchClear: "Clear search",
  gameSearchFilters: "Filters",
  gameSearchRemoveFilter: "Remove filter",
  gameSearchClearFilters: "Clear filters",
  gameSearchProviders: "Providers",
  gameSearchCategories: "CATEGORIES",
  gameSearchResults: "results",
  categoryDice: "Dice",
  categoryFishing: "Fishing",
  categoryVirtualSports: "Virtual Sports",
  categoryTableGames: "Table Games",
  categoryDomino: "Domino",
  categoryPoker: "Poker",
  casinoHeroTitle: "Live Casino",
  casinoHeroAccent: "Real",
  casinoHeroSub: "Live tables with real dealers. The casino experience, from your seat.",
  casinoGamesCount: "Games",
  casinoProviders: "Providers",
  casinoLiveLabel: "Live",
  casinoTrending: "Trending",
  casinoQuickPlay: "Quick Play",
  casinoSearchResults: "Results",
  casinoAllGames: "All live games",
  casinoNoGames: "No games found",
  casinoAll: "All",
  viewAll: "View all",
  loadMore: "Load more",
  previous: "Previous",
  next: "Next",
  casinoWinnersAria: "Latest winners",
  casinoBadgeHot: "Hot",
  casinoBadgeNew: "New",
  casinoBadgePopular: "Popular",
  casinoCatRoulette: "Roulette",
  casinoCatBlackJack: "Blackjack",
  casinoCatBaccarat: "Baccarat",
  casinoCatSicbo: "Sic Bo",
  casinoCatOneBJ: "One Blackjack",
  casinoCatDragonTiger: "Dragon Tiger",
  casinoCatContest: "Contests",
  casinoCatABH: "ABH",
  casinoCatFootball: "Football",
  casinoCatChroma: "Chroma",
};
